import toast from "react-hot-toast";
import axiosInstance from "../../../axiosInstance";

export const getListing = (setData) => {
  axiosInstance
    .get("/hotel/list-summary")
    .then((res) => {
      setData(res.data);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const filterOptions = (setFilterOptions, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .get("/hotel/general/facilities")
    .then((res) => {
      setTimeout(() => {
        setFilterOptions(res.data);
        setIsLoading(false);
      }, 1000);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const filteredHotels = (
  searchName,
  propertyStar,
  hotelName,
  neighbourhood,
  hotelFacilities,
  roomFacilities,
  minPrice,
  maxPrice,
  sorting,
  page,
  limit,
  setIsloading,
  setData,
  setPaginationData,
) => {
  setIsloading(true);
  axiosInstance
    .get(
      `/hotel/search?city=${searchName || ""}&hotelName=${
        hotelName || ""
      }&propertyStar=${propertyStar}&neighbourhood=${neighbourhood}&hotelFacilities=${hotelFacilities}&roomFacilities=${roomFacilities}&minPrice=${minPrice}&maxPrice=${maxPrice}&sorting=price_low_high&page=${page}&limit=${limit}`,
    )
    .then((res) => {
      setTimeout(() => {
        setData(res.data.hotels);
        setPaginationData(res.data.totalPages);

        setIsloading(false);
      }, 1000);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const hotelDetails = (id, setHotelData, setIsloading) => {
  setIsloading(true);
  axiosInstance
    .get(`/hotel/details?hotelId=${id}`)
    .then((res) => {
      setTimeout(() => {
        setHotelData(res.data.hotel);
        setIsloading(false);
      }, 2000);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const mybookingAPi = (setData, orderedBy, Page, Limit, setPageData) => {
  axiosInstance
    .get(`/hotel/hotel/booked/${orderedBy}?page=${Page}&limit=${Limit}`)
    .then((res) => {
      setData(res.data.orders);
      setPageData(res.data.pagination.totalPages);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const mybookingTourAPi = (
  setTour,
  orderedBy,
  Page,
  Limit,
  setPageData,
) => {
  axiosInstance
    .get(`/hotel/tour/booked/${orderedBy}?page=${Page}&limit=${Limit}`)
    .then((res) => {
      setTour(res.data.data);
      setPageData(res.data.totalPages);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const showAllHotel = (SetData) => {
  axiosInstance
    .get(
      "/hotel/search?city=&hotelName=&propertyStar=&neighbourhood=&hotelFacilities=&roomFacilities=&minPrice=&maxPrice=&sorting=price_low_high&page=1&limit=20",
    )
    .then((res) => {
      SetData(res.data.hotels);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
